// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Mainfooter/style.css
// module id = 2227
// module chunks = 29